export default "__VITE_ASSET__B4FxUe9r__"